import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import { TextField, SelectField, DateField, ImageField, Step } from '../SteppedForm';

import rules from './rules';

const StepVehicle = (props) => {
  return (
    <Step
      id="vehicle"
      title="Vehicle - Details"
      skip={(formdata) =>
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        formdata.vehicles[props.state.vehicle_index].carbuy
      }
      key={'vehicledetails-' + props.getVehicle().make}>
      <Grid container>
        <Grid item xs={12} lg={4}>
          <TextField
            id="vin"
            label="VIN"
            valid={rules.vin}
            modify={(value) => props.toUpperCase(value)}
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <div className="composite even">
            <SelectField id="make" label="Make" values={Object.keys(props.getMakes())} required />
            {props.getVehicle().make === 'Other' ? (
              <TextField id="makeother" label="Make Details" required />
            ) : (
              ''
            )}
          </div>
        </Grid>
        <Grid item xs={12} lg={4}>
          <div className="composite even">
            {props.getVehicle().make !== 'Other' ? (
              <SelectField
                id="model"
                label="Model"
                disabled={!props.getVehicle().make}
                values={
                  props.getVehicle().make && props.getMakes()[props.getVehicle().make]
                    ? props.getMakes()[props.getVehicle().make]
                    : []
                }
                required
              />
            ) : (
              ''
            )}
            {props.getVehicle().make &&
            (props.getVehicle().model === 'Other' ||
              !props.getMakes()[props.getVehicle().make] ||
              props.getMakes()[props.getVehicle().make].length === 0) ? (
              <TextField
                id="modelother"
                label={props.getVehicle().make === 'Other' ? 'Model' : 'Model Details'}
                required
              />
            ) : (
              ''
            )}
          </div>
        </Grid>

        {props.stateconfig().oldrego ? (
          <Grid item xs={12} lg={4}>
            <TextField id="old_rego" label="Previous Registration" />
          </Grid>
        ) : (
          ''
        )}
        {!props.networkconfig().colour && !props.stateconfig().colour ? (
          <Grid item xs={12} lg={4}>
            <SelectField id="colour" label="Colour" values={props.config.colours} required />
          </Grid>
        ) : (
          ''
        )}
        {props.stateconfig().carshape ? (
          <Grid item xs={12} lg={4}>
            <SelectField
              id="shape"
              label="Shape"
              values={
                props.networkconfig().wats
                  ? [...props.config.vehicle_shapes, 'Wheelchair']
                  : props.config.vehicle_shapes
              }
              help={
                'If this vehicle is a ' +
                props.getWheelchairTaxiTerm(0) +
                ', please select the Wheelchair option.'
              }
              required
              onClose={() => {
                // TODO: This is one the the worst workarounds I've ever done. Please Fix this if you can manage it.
                setTimeout(() => {
                  if (moment(props.getVehicle().date).isBefore(props.getMaxAge())) {
                    let vehicles = [...props.state.formdata.vehicles];
                    let vehicle = { ...vehicles[props.state.vehicle_index] };
                    vehicle.date = undefined;
                    vehicles[props.state.vehicle_index] = vehicle;
                    props.setState({
                      formdata: {
                        ...props.state.formdata,
                        vehicles: vehicles
                      }
                    });
                  }
                }, 50);
              }}
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={4}>
          <SelectField id="fueltype" label="Fuel Type" values={props.config.fuel_types} required />
        </Grid>
        {props.stateconfig().odometer ? (
          <Grid item xs={12} lg={4}>
            <TextField id="odo" label="Odometer" valid={rules.numeric} required />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={4}>
          <DateField
            id="date"
            key={props.getVehicle().shape}
            label="Manufacture Date"
            format="MM/YYYY"
            minDate={props.getMaxAge()}
            disableFuture
            required
          />
        </Grid>
      </Grid>
      <Grid container>
        {props.stateconfig().seatdetails ? (
          <>
            <Grid item xs={12} lg={3}>
              <TextField
                id="vehicle_frontseats"
                label="# of Front Passenger Seats"
                type="number"
                valid={rules.numeric_bounded(0, 15)}
                required
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <TextField
                id="vehicle_rearseats"
                label="# of Rear Passenger Seats"
                type="number"
                valid={rules.numeric_bounded(0, 15)}
                required
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} lg={props.stateconfig().kidseats ? 4 : 12}>
            <TextField
              id="vehicle_seats"
              label="# of Passenger Seats"
              type="number"
              valid={rules.numeric_bounded(0, 15)}
              required
            />
          </Grid>
        )}
        {props.stateconfig().kidseats ? (
          <>
            <Grid item xs={12} lg={props.stateconfig().seatdetails ? 3 : 4}>
              <TextField
                id="vehicle_kids"
                label="# of Child Seats"
                type="number"
                valid={rules.numeric_bounded(0, 4)}
                required
              />
            </Grid>
            <Grid item xs={12} lg={props.stateconfig().seatdetails ? 3 : 4}>
              <TextField
                id="vehicle_babies"
                label="# of Baby Capsules"
                type="number"
                valid={rules.numeric_bounded(0, 4)}
                required
              />
            </Grid>
          </>
        ) : (
          ''
        )}
      </Grid>
      <Typography variant="body1" class="formQuestion">
        If you do not have these documents yet, you will be asked to provide them at a later stage.
      </Typography>
      <Grid container className="bottom-pad" spacing={2}>
        {props.stateconfig().roadworthy ? (
          <Grid item sm>
            <ImageField
              id="roadworthy"
              label="Roadworthiness Certificate"
              height={194}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
              help="This may be a Pink or Blue slip, as appropriate, and may be provided by 13cabs or other registered inspection station"
            />
          </Grid>
        ) : (
          ''
        )}
        {props.stateconfig().ctp ? (
          <Grid item sm>
            <ImageField
              id="ctp_coc"
              label="CTP Certificate of Currency"
              height={194}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
              required={props.state.formdata.state === 'nt'}
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item sm>
          <ImageField
            id="registration"
            label="Registration"
            height={194}
            width={128}
            min_filesize={1000}
            max_filesize={5242880}
            acceptAll
          />
        </Grid>
        {props.stateconfig().extravehiclecert ? (
          <Grid item sm>
            <ImageField
              id="extravehiclecert"
              label={props.stateconfig().extravehiclecert}
              height={194}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
            />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </Step>
  );
};

export default StepVehicle;
